var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentComponent,{tag:"component",attrs:{"cumplusoryFee":_vm.cumplusoryFee,"optionalFee":_vm.optionalFee,"ledger":_vm.ledger,"percentage":_vm.percentage,"History":_vm.History}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }